import { BuiltCampaignControllerTrigger } from "./BuiltCampaignControllerTrigger";
export const isBuiltCampaignControllerTriggerZoneState = (trigger) => trigger instanceof BuiltCampaignControllerTriggerZoneState;
export class BuiltCampaignControllerTriggerZoneState extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
        this.zoneName = response.zone_name;
        this.stepName = response.step_name;
        this.invertMappingState = response.invert_mapping_state;
    }
    getDisplayName() {
        return this.trigger_name || "Zone State Trigger";
    }
}
